import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'margemcontribuicao');

const margemContribuicaoActions = {
  listar: { method: 'GET', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, margemContribuicaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/margem-contribuicao.js